


























































































































import Vue from 'vue'
import {
  Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import MainButton from '@/shared/buttons/main-button.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import Pagination from '@/domain/pagination.entity';
import ContractGroupFilterBind from '@/domain/contract/entity/contract-group-filter-bind.entity';
import ContractList from '@/domain/contract/entity/contract-list.entity';
import ModalOptions from '@/shared/modal/modal-options.entity';
import FilterBindComponent from './contract-group-filter-bind.component.vue';
import Header from './header-modal-contract.json'

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    MainButton,
    ModalWarning,
    FilterBindComponent,
    VbPagination,
  },
})
export default class ContractGroupBindModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  pagination!: Pagination;

  @Prop({ required: true })
  contracts!: ContractList[];

  @Prop()
  loadingTable!: boolean;

  @Prop({ required: true })
  filter!: ContractGroupFilterBind;

  @Prop({ required: true })
  selectedAllContracts: boolean = false;

  @Prop()
  groupName!: string;

  header: any = Header;

  warningModal: boolean = false;

  warningMessage: string = '';

  loading: boolean = false;

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    return {
      title: `Vincular Contratos ao Grupo ${this.groupName}`,
      titleAlign: 'center',
      showClose: true,
      showCancel: true,
      labelCancel: 'Fechar',
      width: 1250,
      persistent: true,
    }
  }

  get totalSelected(): number {
    return this.contracts.filter((item: ContractList) => item.selected).length;
  }

  applyFilter(filter: ContractGroupFilterBind) {
    this.$emit('filter', filter);
  }

  updateTable(pagination: Pagination) {
    this.$emit('updateTable', pagination);
  }

  updateSelectedAllContract() {
    this.contracts.forEach((item: ContractList) => {
      item.selected = this.selectedAllContracts;
    });
  }

  openWarningModal(): void {
    this.warningModal = true;
    this.warningMessage = 'Deseja realmente <strong style="color: orange">víncular</strong> os contratos selecionados? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  confirmBindAllSelected(): void {
    this.loading = true;
    const listContractsId = this.contracts.filter((item: ContractList) => item.selected)
      .map((it) => it.id);
    this.warningModal = false;
    this.$emit('bindContracts', listContractsId);
    this.cancel();
    this.loading = false;
  }
}
